// Optional concrete pictures for times tables and equal sharing. Hints still count as assisted work.
export function blockHint(q) {
  if (!['mul', 'div'].includes(q.topic)) return null;
  const numbers = q.text.match(/\d+/g)?.map(Number);
  if (!numbers || numbers.length !== 2) return null;
  const [a, b] = numbers,
    rows = q.topic === 'mul' ? a : b,
    cols = q.topic === 'mul' ? b : a / b;
  if (!Number.isInteger(rows) || !Number.isInteger(cols) || rows < 1 || cols < 1 || rows > 12 || cols > 12) return null;
  return {
    kind: 'groups',
    rows,
    cols,
    label:
      q.topic === 'mul'
        ? `${rows} rows of ${cols} blocks. Count in ${cols}s.`
        : `Share ${a} blocks into ${rows} equal rows. How many in each row?`,
  };
}
